import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, User, X } from "lucide-react";

const linkClass = "text-xs uppercase tracking-[0.25em] text-muted transition-colors duration-500 hover:text-gold";
const mobileLinkClass = `${linkClass} flex min-h-11 items-center`;

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goStoria = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (pathname === "/") {
      document.getElementById("storia")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => document.getElementById("storia")?.scrollIntoView({ behavior: "smooth" }), 500);
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-line bg-void/80 backdrop-blur-xl">
      <div className="flex h-20 items-center justify-between px-6 lg:px-12">
        <Link to="/" data-testid="header-logo" onClick={() => setMenuOpen(false)} className="flex items-center gap-3" aria-label="Orologi e Preziosi — Home">
          <img src="/media/logo-mark.png" alt="Logo Orologi e Preziosi" className="h-10 w-10 object-contain" data-testid="header-logo-image" />
          <span className="hidden font-serif text-xl tracking-tight text-ivory min-[430px]:block lg:text-2xl">
            Orologi <span className="italic text-gold">&amp;</span> Preziosi
          </span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          <a href="/#storia" onClick={goStoria} data-testid="nav-storia" className={linkClass}>
            La Nostra Storia
          </a>
          <Link to="/catalogo?categoria=orologi" data-testid="nav-orologi" className={linkClass}>
            Orologi
          </Link>
          <Link to="/catalogo?categoria=gioielli" data-testid="nav-gioielli" className={linkClass}>
            Gioielli
          </Link>
        </nav>

        <div className="flex items-center gap-6">
          <Link
            to="/admin"
            data-testid="header-admin-link"
            aria-label="Area riservata"
            className="flex h-11 w-11 items-center justify-center text-muted transition-colors duration-500 hover:text-gold"
          >
            <User size={18} strokeWidth={1.5} />
          </Link>
          <button
            onClick={() => setMenuOpen((open) => !open)}
            data-testid="mobile-menu-button"
            aria-label={menuOpen ? "Chiudi menu" : "Apri menu"}
            aria-expanded={menuOpen}
            className="flex h-11 w-11 items-center justify-center text-ivory transition-colors duration-500 hover:text-gold md:hidden"
          >
            {menuOpen ? <X size={21} strokeWidth={1.5} /> : <Menu size={21} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav data-testid="mobile-menu" className="absolute inset-x-0 top-full border-b border-line bg-void/95 px-6 py-7 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-6">
            <a href="/#storia" onClick={goStoria} data-testid="mobile-nav-storia" className={mobileLinkClass}>
              La Nostra Storia
            </a>
            <Link to="/catalogo?categoria=orologi" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-orologi" className={mobileLinkClass}>
              Orologi
            </Link>
            <Link to="/catalogo?categoria=gioielli" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-gioielli" className={mobileLinkClass}>
              Gioielli
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
